import React, { useState } from 'react';
import indexCss from './newmap.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons';

interface Props {
  list: {
    layerName: string;
    legend: {
      imageData: string;
      label: string;
    }[];
  };
}

export default function LegendItem({ list }: Props) {
  const [visible, setVisible] = useState(true);

  return (
    <div>
      <div
        className={
          indexCss['legend-list-item'] +
          ' ' +
          (list.legend.length > 1 ? indexCss['legend-chev-item'] : '')
        }
        onClick={() => setVisible((prevVisible) => !prevVisible)}
      >
        {list.legend.length > 1 ? (
          <FontAwesomeIcon
            icon={faChevronDown}
            className={indexCss['chev-icon']}
          />
        ) : (
          <img
            src={'data:image/png;base64, ' + list.legend[0].imageData}
            alt=""
          />
        )}

        {list.layerName}
      </div>
      {visible && list.legend.length > 1 && (
        <div className={indexCss['legend-container']}>
          {list.legend.map((legend) => (
            <div className={indexCss['legend-item']}>
              <img
                src={'data:image/png;base64, ' + legend.imageData}
                className={indexCss['base-image']}
                alt=""
              />
              {legend.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
